import React, { useState, useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { StoreContext } from '../../contexts/StoreContext';
import Logo from './Logo';
import styles from './Login.module.css';

const Login = observer(() => {
    const rootStore = useContext(StoreContext);
    const { auth, notifications } = rootStore;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('error');

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Сброс ошибок
        setErrors({});
        setShowAlert(false);
        
        // Валидация
        const newErrors = {};
        if (!username.trim()) {
            newErrors.username = 'Введите имя пользователя';
        }
        if (!password) {
            newErrors.password = 'Введите пароль';
        }
        
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        
        // Выполняем вход
        try {
            await auth.login(username.trim(), password);
            
            // Успешный вход
            setAlertType('success');
            setAlertMessage('Вход выполнен успешно');
            setShowAlert(true);
            notifications.success('Успешный вход в систему');
            
        } catch (error) {
            // Ошибка входа
            setAlertType('error');
            setAlertMessage(error.message || 'Неверное имя пользователя или пароль');
            setShowAlert(true);
        }
    };

    return (
        <div className={styles.loginPage}>
            <div className={styles.container}>
                <div className={styles.card}>
                    <div className={styles.header}>
                        <Logo className={styles.logo} />
                        <h1 className={styles.title}>Система генерации КП</h1>
                        <p className={styles.subtitle}>Введите ваши учетные данные</p>
                    </div>
                    
                    <div className={styles.body}>
                        {showAlert && (
                            <div className={`${styles.alert} ${alertType === 'error' ? styles.alertError : styles.alertSuccess}`}>
                                {alertMessage}
                            </div>
                        )}
                        
                        <form onSubmit={handleSubmit}>
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel} htmlFor="username">
                                    Имя пользователя
                                </label>
                                <input 
                                    type="text" 
                                    id="username"
                                    className={`${styles.formControl} ${errors.username ? styles.error : ''}`}
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    placeholder="Введите имя пользователя"
                                    autoComplete="username"
                                />
                                {errors.username && (
                                    <div className={`${styles.formError} ${styles.show}`}>
                                        {errors.username}
                                    </div>
                                )}
                            </div>
                            
                            <div className={styles.formGroup}>
                                <label className={styles.formLabel} htmlFor="password">
                                    Пароль
                                </label>
                                <input 
                                    type="password" 
                                    id="password"
                                    className={`${styles.formControl} ${errors.password ? styles.error : ''}`}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Введите пароль"
                                    autoComplete="current-password"
                                />
                                {errors.password && (
                                    <div className={`${styles.formError} ${styles.show}`}>
                                        {errors.password}
                                    </div>
                                )}
                            </div>
                            
                            <button 
                                type="submit" 
                                className={styles.submitBtn}
                                disabled={auth.isLoading}
                            >
                                {auth.isLoading ? (
                                    <>
                                        Вход...
                                        <span className={styles.spinner}></span>
                                    </>
                                ) : (
                                    'Войти'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default Login;